"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _CoreProps = require("../utilities/CoreProps");
var _Image = _interopRequireDefault(require("./Image"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Thumbnail = _ref => {
  let {
    src,
    caption,
    size,
    color,
    position,
    className,
    getAssetUrl,
    renderAs
  } = _ref;
  const classNames = (0, _classnames.default)({
    [`is-${position}`]: position,
    [`is-${color}`]: color
  });
  const RenderAs = renderAs;
  return /*#__PURE__*/_react.default.createElement(RenderAs, {
    className: (0, _classnames.default)('thumbnail', className, classNames) || undefined
  }, /*#__PURE__*/_react.default.createElement(_Image.default, {
    src: src,
    getAssetUrl: getAssetUrl,
    alt: caption,
    size: size,
    caption: caption
  }));
};
Thumbnail.propTypes = {
  src: _propTypes.default.string,
  caption: _propTypes.default.string,
  color: _propTypes.default.oneOfType([_propTypes.default.oneOf(['primary', 'link', 'info', 'success', 'warning', 'danger', 'dark', 'text', 'white']), _propTypes.default.string]),
  size: _propTypes.default.oneOfType([_propTypes.default.oneOf([16, 24, 32, 48, 64, 96, 128, 'square', '1by1', '4by3', '3by2', '16by9', '2by1', '5by4', '5by3', '3by1', '4by5', '3by4', '2by3', '3by5', '9by16', '1by2', '1by3']), _propTypes.default.number, _propTypes.default.string]),
  position: _propTypes.default.oneOfType([_propTypes.default.oneOf(['top', 'right', 'bottom', 'left', 'center']), _propTypes.default.string]),
  className: _propTypes.default.string,
  getAssetUrl: _propTypes.default.func,
  renderAs: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.object])
};
Thumbnail.defaultProps = {
  color: 'white',
  position: 'bottom',
  titleSize: 3,
  className: '',
  getAssetUrl: url => url,
  renderAs: 'div',
  size: '16by9'
};
var _default = exports.default = (0, _CoreProps.withUiProps)(Thumbnail);
//# sourceMappingURL=Thumbnail.js.map